export enum WidgetView {
  PAYMENT_RESULT = 'payment_result',
  SUBSCRIPTION_CANCEL = 'subscription_cancel',
  SUBSCRIPTION_CANCEL_RESULT = 'subscription_cancel_result',
  SUBSCRIPTION_PAYMENT_METHOD_UPDATE = 'subscription_payment_method_update',
  SUBSCRIPTION_PAYMENT_METHOD_UPDATE_RESULT = 'subscription_payment_method_update_result',
}
